import { useEffect, useState, useContext, useRef } from "react";
import { CircularProgress } from "@mui/material";
import MUICard from "../../../Component/UI/MUICard/MUICard";
import classes from "./History.module.css";
import HistoryItem from "./HistoryItem";
import LoadingSkeleton from "./LoadingSkeleton";
import EmptyView from "../../../Component/EmptyView/EmptyView";
import { AuthContext } from "../../../context/auth-context";
import useHistory from "./useHistory";
import MUIButton from "../../../Component/UI/MUIButton/MUIButton";
import ErrorView from "../../../Component/ErrorView/ErrorView";
import ErrorMessage from "../../../Component/ErrorMessage/ErrorMessage";
import { DiscoveryContext } from "../discovery-context";
import api from "../../../BrandOnBoarding/api";
import OldHistoryItem from "../../Discovery/History/HistoryItem";
import { set } from "lodash";

function hasData(obj, type) {
  const baseExpectedTypes = {
    name: "string",
    llm: "string",
    type: "string",
    competitors: "object",
    brand_scores: "object",
    category_dimensions: "object",
  };

  let expectedTypes = { ...baseExpectedTypes };

  if (type === "brand") {
    expectedTypes.core_attributes = "object";
    // expectedTypes.top_products = "object";
    expectedTypes.brand_description = "string";
    expectedTypes.brand_snippets = "object";
    expectedTypes.brand_themes = "object";
    expectedTypes.entity = "string";
    expectedTypes.positive_negative_attributes = "object";
    // expectedTypes.sources=  "object";
  } else if (type === "product") {
    expectedTypes.taxonomies = "object";
    expectedTypes.brand_description = "string";
    expectedTypes.brand_snippets = "object";
    expectedTypes.brand_themes = "object";
    expectedTypes.entity = "string";
    expectedTypes.positive_negative_attributes = "object";
    // expectedTypes.sources=  "object";
  } else if (type === "category") {
    expectedTypes.taxonomies = "object";
  }

  for (const key in expectedTypes) {
    if (expectedTypes.hasOwnProperty(key)) {
      const expectedType = expectedTypes[key];
      const actualValue = obj[key];

      // Check if the property exists in the object
      if (!(key in obj)) {
        return false;
      }

      const actualType = Array.isArray(actualValue)
        ? "object"
        : typeof actualValue;

      if (actualType !== expectedType) {
        return false;
      }

      if (expectedType === "object" && Array.isArray(actualValue)) {
        if (
          actualValue.length === 0 &&
          key !== "category_dimensions" &&
          key !== "core_attributes" &&
          key !== "positive_negative_attributes" &&
          key !== "brand_themes"
        ) {
          return false;
        }
        if (key === "brand_scores") {
          if (
            type === "category"
              ? actualValue.length === 0
              : actualValue.length !== 4 ||
              actualValue.some(
                (item) =>
                  item === null ||
                  item === undefined ||
                  !item.hasOwnProperty("total") ||
                  item.hasOwnProperty("error")
              )
          ) {
            return false;
          }
        }
      } else if (expectedType === "object" && !Array.isArray(actualValue)) {
        // Check if the object is empty for specific keys
        if (
          (key === "category_dimensions" ||
            key === "core_attributes" ||
            key === "positive_negative_attributes" ||
            key === "brand_themes") &&
          Object.keys(actualValue).length === 0
        ) {
          return false;
        }
      } else if (expectedType === "string" && actualValue.trim() === "") {
        return false;
      }
    }
  }
  return true;
}

const PAGE_LIMIT = 5;

export default function History({ filter = "brand", setCancelTransaction = () => { }, startPolling = () => { }, isHistoryRefresh = false, setIsHistoryRefresh = () => { } }) {
  const [filterOption, setFilterOption] = useState(filter);
  const { authUserEmail } = useContext(AuthContext);
  const [oldPage, setOldPage] = useState(1);
  const [isUsingOldHistory, setIsUsingOldHistory] = useState(false);
  const discoveryCtx = useContext(DiscoveryContext);
  const {
    history,
    setHistory,
    loading,
    getHistory,
    deleteHistory,
    updateHistory,
    error,
    hasReachedEnd,
    setHasReachedEnd,
    page,
    setPage,
    setLoading
  } = useHistory(filterOption);
  const abortCtrlRef = useRef();
  const state = discoveryCtx.state;

  useEffect(() => {
    setFilterOption(filter);
    setIsUsingOldHistory(false);
    setOldPage(1);
    setHistory([]);
    setHasReachedEnd(false);
    setPage(1);
  }, [filter]);

  useEffect(() => {
    setPage(1);
  }, [isHistoryRefresh]);

  useEffect(() => {
    setLoading(true);
    async function fetchNewHistory() {
      const newHistory = await getHistory(page, PAGE_LIMIT);
      console.log('New History Fetched:', 'newhistory', newHistory, 'history', history, 'ishistoryrefresh', isHistoryRefresh, 'page', page);

      if (newHistory?.length > 0) {
        setHistory(prev => {
          const merged = page === 1 ? newHistory : [...prev, ...newHistory];
          const seen = new Set();

          return merged.reduce((acc, item) => {
            const key = item.id ?? item.transactionId
              ;
            if (!seen.has(key)) {
              seen.add(key);
              acc.push(item);
            }
            return acc;
          }, []);
        });

        setHasReachedEnd(false);
        setIsUsingOldHistory(false);
      } else {
        setHasReachedEnd(false);
        setOldPage(1);
        setIsUsingOldHistory(true);

      }
    }

    setTimeout(async () => {
      await fetchNewHistory();
      setLoading(false);
    }, 300);


  }, [page, filter, isHistoryRefresh]);

  useEffect(() => {
    if (!isUsingOldHistory) return;
    setLoading(true);
    async function fetchOldHistory() {
      console.log('new history exhausted, fetching old history', 'oldpage', oldPage, 'isusingoldhistory', isUsingOldHistory);

      const oldHistory = await getOldHistory(oldPage, PAGE_LIMIT);
      if (oldHistory?.length > 0) {
        setHistory(prev => {
          const merged = [...prev, ...oldHistory];
          const seen = new Set();

          return merged.reduce((acc, item) => {
            const key = item.id ?? item.transactionId;
            if (!seen.has(key)) {
              seen.add(key);
              acc.push(item);
            }
            return acc;
          }, []);
        });

        if (oldHistory.length < PAGE_LIMIT) {
          setHasReachedEnd(true);
        }
      } else {
        setHasReachedEnd(true);

      }
    }

    setTimeout(async () => {
      await fetchOldHistory();
      setLoading(false);
    }, 300);

  }, [oldPage, isUsingOldHistory]);


  async function getOldHistory(page = 1, limit = 5) {
    try {
      setLoading(true);
      const response = await api.get(
        `/users/discovery?user_email=${encodeURIComponent(authUserEmail)}&page=${page}&limit=${limit}&type=${filterOption}`
      );
      const data = response.data;
      const newHistory = data.data.map(item => {
        return {
          ...item,
          market: item?.json_data?.market
        }
      })
      return newHistory
    } catch (error) {
      if (error.name === "CanceledError") {
        return;
      }
    }
  }

  async function deleteHistoryItemHandler(id) {
    discoveryCtx.resetState();
    await deleteHistory(id);
    setHistory([])
    setPage(1);
    setIsHistoryRefresh(prev => !prev);
    setIsUsingOldHistory(false);
    setOldPage(1);
  }

  useEffect(() => {
    const type = state.type ?? "brand";
    if (hasData(state, type)) {
      if (!state.id && type !== "category") {
        console.log("All Record Completed", state);
        discoveryCtx.updateLoading(false);
      }
    } else {
      if (state.id) {
        discoveryCtx.updateLoading(false);
      } else if (state.is_launched) {
        discoveryCtx.updateLoading(true);
      }
    }
  }, [hasData(state, state.type)]);



  return (
    <MUICard variant="elevated" elevation={0} className={classes.card}>
      <div className={classes.header}>
        <div className={classes.leftGroup}>
          <span className={classes.title}>History</span>
        </div>
      </div>

      {history?.length > 0 && (
        <div className={classes.container}>
          {history?.map((historyItem) => (
            historyItem?.json_data ?
              <OldHistoryItem
                key={historyItem.id}
                item={historyItem}
                onDelete={() => { }}
                onUpdate={() => { }}
                isOldHistory={true}
              />
              :
              <HistoryItem
                key={historyItem.transactionId}
                item={historyItem}
                onDelete={deleteHistoryItemHandler}
                isOldHistory={false}
                setCancelTransaction={setCancelTransaction}
                startPolling={startPolling}
              // onUpdate={(id, name) => updateHistory(id, name)}
              />
          ))}
          <div className={classes.load_more}>
            {error && history?.length > 0 && (
              <div className={classes.error_message}>
                <ErrorMessage message={error} />
              </div>
            )}
            {!loading && !hasReachedEnd && (
              <MUIButton
                className={classes.load_btn}
                variant="text"
                onClick={() => {
                  // setPage((page) => page + 1);
                  if (!isUsingOldHistory) {
                    setPage(prev => prev + 1);
                  } else {
                    setOldPage(prev => prev + 1);
                  }
                }}
              >
                Load More
              </MUIButton>
            )}

            {loading && <CircularProgress size={22} />}
          </div>
        </div>
      )}
      {loading && history.length === 0 && <LoadingSkeleton />}
      {!loading && !error && history.length === 0 && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "70%" }}
        >
          <EmptyView message={"Nothing here."} />
        </div>
      )}
      {error && history.length === 0 && (
        <div className={classes.error}>
          <ErrorView title="Error" message={error} />
        </div>
      )}
    </MUICard>
  );
}
